t = require('app/scripts/views/internal/teacup-with-helpers')('edit_attachment')

module.exports = ->
  t.form ->
    if (t.mustacheVar('serviceKey') == 'other')
      t.label ->
        t.format('attachment-url')
        t.input '.js-attachment-url', { type: 'text', value: t.mustacheVar('url') }

    t.label ->
      if (t.mustacheVar('serviceKey') == 'other')
        t.format('attachment-name-optional')
      else
        t.format('attachment-name')
      t.input '.js-attachment-name.js-autofocus', { type: 'text', value: t.mustacheVar('name') }


    t.input '.js-edit-attachment.wide.primary', { style: 'margin: 0;', type: 'submit', value: t.l('update-attachment') }
